<template>
  <div class="gender-switch-container mb-3">
    <label>
      <question-display :question="question"  customClass="header-switch"></question-display>
    </label>
    <div class="gender-buttons" data-toggle="buttons" role="group">
      <label class="btn btn-default" :class="{ active: inputValue === 'Male' }" @click="selectGender('male')">
        <input type="radio" name="gender" value="Male" v-model="inputValue" hidden />
        <span><img :src="require('@/assets/img/male.png')" width="40" height="40" alt="Male" /></span>
        <p>Male</p>
      </label>
      <label class="btn btn-default" :class="{ active: inputValue === 'Female' }" @click="selectGender('female')">
        <input type="radio" name="gender" value="Female" v-model="inputValue" hidden />
        <span><img :src="require('@/assets/img/female.png')" width="40" height="40" alt="Female" /></span>
        <p>Female</p>
      </label>
    </div>
    <small v-if="showValidation && question.required && !inputValue" class="text-danger">This field is required.</small>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
      QuestionDisplay
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean // Add showValidation prop
  },
  data() {
    return {
      inputValue: surveyService.getAnswer(this.question.id) || ''
    };
  },
  methods: {
    selectGender(gender) {
      // Capitalize first letter to match the options format (Male/Female)
      this.inputValue = gender.charAt(0).toUpperCase() + gender.slice(1);
      surveyService.setAnswer(this.question.id, this.inputValue); // Save the answer directly through the service
      this.$emit("input", this.inputValue);
    }
  },
  watch: {
    question(newQuestion) {
      this.inputValue = surveyService.getAnswer(newQuestion.id) || '';
    }
  }
};
</script>